module.exports = __webpack_public_path__ + "assets/img/rzeczpospolita.015e5036.png";